// about vue-i18n
// The MIT License (MIT)
//
// Copyright (c) 2016 kazuya kawaguchi
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

import { useI18n } from 'vue-i18n';

// i18n wrapper function of javascript . 
// i18nのラッパー関数
// i18nがnullになってしまうOSSの不具合を回避するためのwrapper

export default {
  install(Vue) {
    const _$t = Vue.config.globalProperties.$t;
    const _$te = Vue.config.globalProperties.$te;
    Vue.config.globalProperties._$t = _$t;
    Vue.config.globalProperties._$te = _$te;

    function getMessage(self, targetFunction, args, usei18n$te = false) {
      if (args.length > 0 && !args[0]) {
        // 空のキーが指定された場合はデフォルトのメッセージを返す
        return usei18n$te ? false : args[0];
      }
      if (self.$i18n) {
        if (args.length > 0 && !args[0]) {
          // 空のキーが指定された場合はデフォルトのメッセージを返す
          return usei18n$te ? false : args[0];
        } else {
          return targetFunction.apply(self, args);
        }
      } else {
        //console.log("$i18n is NULL");
        return targetFunction.apply(self.$root, args);
      }
    }

    // i18n $t function のラップ関数
    Vue.config.globalProperties.$t = function () {
      return getMessage(this, _$t, arguments);
    };

    // i18n $te function のラップ関数
    Vue.config.globalProperties.$te = function () {
      const result = getMessage(this, _$te, arguments, true);
      return result;
    };
  }
};

/**
 * useI18n用のWrapper
 * @returns Wrapした関数を保持するオブジェクト
 */
export function WrappedUseI18n() {

  function getMessage(targetFunction, args, isTeFunction = false) {
    if (args.length > 0 && !args[0]) {
      // 空のキーが指定された場合はデフォルトのメッセージを返す。$teであればfalse、それ以外はキー自体
      return isTeFunction ? false : args[0];
    }

    return targetFunction(...args);
  }

  const { t, te } = useI18n();

  const wrappedT = (...args) => {
    return getMessage(t, args);
  };
  const wrappedTe = (...args) => {
    return getMessage(te, args, true);
  };

  return { t: wrappedT, te: wrappedTe };
}
